import { modifyLinkBehavior, isMobileBreakpoint } from '../utils.js';

export default function () {
  const widgetName = 'venueCardsWidget';
  const widgetOpts = venueCardsWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function whiteButtons(cards) {
    cards.each(function () {
      const card = $(this);
      const moreButton = card.find('.moreButton');
      if (moreButton.length > 0) {
        moreButton.addClass('white-button');
      }
    });
  }
  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (!hasData) {
        $widgetHTML.parent().remove();
      } else {
        modifyLinkBehavior(data, cards);
        whiteButtons(cards);
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: isMobileBreakpoint ? ['all'] : [''],
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
